export default {
      id: "calendar-bold-usage",
      viewBox: "0 0 18 19",
      url: __webpack_public_path__ + "sprite-46b249.svg#calendar-bold-usage",
      toString: function () {
        return this.url;
      }
    }